export enum BOOLEAN_CHIP_VALUE {
  And = "and",
  Or = "or",
  Not = "not",
}

export const BOOLEAN_ITEMS = [
  BOOLEAN_CHIP_VALUE.And,
  BOOLEAN_CHIP_VALUE.Or,
  BOOLEAN_CHIP_VALUE.Not,
];
